/**
 * A person's initials, the one rule the app shell's avatar and the board's owner badge
 * both use — see `specs/board/card-density.md`. Two derivations of "this person's
 * initials" is how the top bar and a card start disagreeing about the same manager.
 *
 * First letter of the first word plus first letter of the last word, uppercase, with
 * diacritics preserved (`Hana Novotná` → `HN` — nothing is stripped or normalised). A
 * single-word name yields just its own first letter rather than doubling it.
 *
 * Two managers can land on the same pair (`Petr Novák` and `Pavel Novotný` both read
 * `PN`) — accepted deliberately: colour, the tooltip and the accessible label
 * disambiguate, and the alternative (more letters for the rare collision) uglifies the
 * common case.
 */
export function initials(name: string): string {
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";

  const first = words[0]!;
  if (words.length === 1) return first[0]!.toUpperCase();

  const last = words[words.length - 1]!;
  return (first[0]! + last[0]!).toUpperCase();
}
